import { MatSnackBar } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { take } from "rxjs/operators";
import { DialogUtilsService } from "../dialog-utils/dialog-utils.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../dialog-utils/dialog-utils.service";
/**
 * Servicio general que encapsula el envio de mensajes al usuario
 * por parte del resto de componentes de la aplicacion
 *
 * Se encapsula para poder desacoplar los mensajes de confirmacion y
 * error de un componente especifico y que pueda cambiarse de forma global
 * rapidamente
 */
var MensajeriaUsuarioService = /** @class */ (function () {
    function MensajeriaUsuarioService(matSnackbar, translateService, dialogService) {
        this.matSnackbar = matSnackbar;
        this.translateService = translateService;
        this.dialogService = dialogService;
        this.duracionNotificacion = 5000;
    }
    MensajeriaUsuarioService.prototype.notificarExito = function (mensaje, callback, panelClass) {
        this.dialogService.abrirSuccess({
            mensaje: mensaje,
            success: callback,
            panelClass: panelClass
        });
    };
    MensajeriaUsuarioService.prototype.notificarError = function (mensaje, callback) {
        this.dialogService.abrirError({
            mensaje: mensaje,
            panelClass: 'new_style'
        });
    };
    MensajeriaUsuarioService.prototype.mostrarSnackbar = function (mensaje, callback, estilos) {
        var _this = this;
        this.translateService
            .get("ACCEPT")
            .pipe(take(1))
            .subscribe(function (textoAceptar) {
            var snackBarRef = _this.matSnackbar.open(mensaje, textoAceptar, {
                panelClass: estilos,
            });
            snackBarRef
                .afterDismissed()
                .pipe(take(1))
                .subscribe(function () {
                if (callback) {
                    callback();
                }
            });
        });
    };
    MensajeriaUsuarioService.ngInjectableDef = i0.defineInjectable({ factory: function MensajeriaUsuarioService_Factory() { return new MensajeriaUsuarioService(i0.inject(i1.MatSnackBar), i0.inject(i2.TranslateService), i0.inject(i3.DialogUtilsService)); }, token: MensajeriaUsuarioService, providedIn: "root" });
    return MensajeriaUsuarioService;
}());
export { MensajeriaUsuarioService };
